// Theme colours and UK formatters — carried over unchanged from the original dashboard.

export const C = {
  bg: '#05101F', surf: '#091624', card: '#0D1D30', bdr: '#1A3250',
  gold: '#D4A843', teal: '#1EC8B8', blue: '#5AABF8', pink: '#F472B6',
  green: '#22C55E', amb: '#F59E0B', org: '#F97316', red: '#EF4444',
  purp: '#B09EFF', steel: '#6CA4C8',
  bright: '#ECFFFF', text: '#D0E8FF', dim: '#8CC8E8', lbl: '#6AB8D8',
};

// ── UK currency / number formatting (en-GB throughout) ──
export const fmt = n => `£${Math.round(n || 0).toLocaleString('en-GB')}`;
export const fmtK = n => `£${Math.round((n || 0) / 1000)}k`;
export const pct = n => `${(n || 0).toFixed(1)}%`;
export const incK = v => {
  const k = (v || 0) / 1000;
  return '£' + (Number.isInteger(k) ? k.toFixed(0) : k.toFixed(1)) + 'k';
};

// Signed currency, for variance figures
export const fmtSigned = n => {
  const v = Math.round(n || 0);
  return (v >= 0 ? '+' : '−') + '£' + Math.abs(v).toLocaleString('en-GB');
};
export const pctSigned = n => {
  if (!Number.isFinite(n)) return '—';
  return (n >= 0 ? '+' : '−') + Math.abs(n).toFixed(1) + '%';
};

// ── UK dates ──
export const fmtDate = iso => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};
export const fmtDateTime = iso => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) +
    ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
};

// Colour-code a retirement year: sooner is greener.
export function retCol(y) {
  if (y <= 2031) return C.green;
  if (y <= 2034) return '#86EFAC';
  if (y <= 2037) return C.amb;
  if (y <= 2040) return '#FBBF24';
  if (y <= 2044) return C.org;
  return C.red;
}

// ── Chart.js shared styling ──
export const CJSTT = {
  backgroundColor: '#091624', borderColor: '#1A3250', borderWidth: 1,
  titleColor: '#ECFFFF', bodyColor: '#D0E8FF', padding: 12, cornerRadius: 6,
};

export const mkScale = yfmt => ({
  x: { ticks: { color: '#8CC8E8', font: { size: 11 } }, grid: { color: '#1A3250' }, border: { color: '#1A3250' } },
  y: { ticks: { color: '#8CC8E8', font: { size: 11 }, callback: yfmt || (v => `£${v}k`) }, grid: { color: '#1A3250' }, border: { color: '#1A3250' } },
});

// Shared disclaimer wording — kept verbatim from the original.
export const DISCLAIMER =
  'This is illustrative modelling, not regulated financial advice. Confirm any approach ' +
  'with a financial adviser before acting.';
